export const PAGE_SIZE = 10

/**
 * Calculate the target page after an action (delete, activate, etc.)
 * - Stay on current page if more than 1 record exists on it
 * - Go to previous page if only 1 record exists (it will be empty after action)
 */
export const calculatePageAfterAction = (currentPage, itemsOnCurrentPage) => {
  if (currentPage <= 1) return 1
  if (itemsOnCurrentPage <= 1) return currentPage - 1
  return currentPage
}

export const calculateStartIndex = (page) => (page - 1) * PAGE_SIZE
